import { Currency } from "../models/currency";
import BaseService from "./_base.service";

const endpoint = "currencies";

const CurrencyService = {
  ...BaseService<Currency>({ endpoint })
};

export default CurrencyService;
